import React from 'react';

import { WALLPAPER_ERROR_MESSAGES } from '@wetransfer/transfer/modules/ad-sdk-wallpaper/constants';
import ErrorHandler from '@wetransfer/transfer/modules/error-handler';

export class ErrorBoundary extends React.PureComponent {
  state = {
    hasError: false,
  };

  static getDerivedStateFromError(): { hasError: boolean } {
    return { hasError: true };
  }

  componentDidCatch(error: Error): void {
    ErrorHandler.track(new Error(WALLPAPER_ERROR_MESSAGES.ERROR_BOUNDARY), {
      errorMessage: error.message,
    });
  }

  render(): React.ReactNode {
    if (this.state.hasError) {
      return <></>;
    }

    return this.props.children;
  }
}
